import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

export type MomentFormat = string | 'date' | 'datetime';

@Pipe({
  name: 'moment',
  standalone: true,
})
export class MomentPipe implements PipeTransform {
  /* see https://momentjs.com/docs/#/displaying/ for format strings */
  transform(value: moment.Moment | string | undefined, format: MomentFormat = 'datetime'): string {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      value = moment(value);
    }
    let formatX;
    if (format === 'date') {
      formatX = 'DD.MM.YYYY';
    } else if (format === 'datetime') {
      formatX = 'DD.MM.YYYY HH:mm';
    } else {
      formatX = format;
    }
    return value.local().format(formatX);
  }
}
